import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import splashImage from '../images/splashscreen.png';

const SignUp = ({ onSignIn, onGoToLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSignUp = (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        const auth = getAuth();
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                console.log(user);
                onSignIn();
            })
            .catch((error) => {
                let customErrorMessage = "An unknown error occurred. Please try again.";
                switch (error.code) {
                    case 'auth/email-already-in-use':
                        customErrorMessage = "This email is already in use. Please try logging in or use a different email.";
                        break;
                    case 'auth/invalid-email':
                        customErrorMessage = "Invalid email address format.";
                        break;
                    case 'auth/weak-password':
                        customErrorMessage = "Password is too weak. Please use a stronger password.";
                        break;
                    case 'auth/password-does-not-meet-requirements':
                        customErrorMessage = (
                            <div>
                                <p>Password does not meet requirements:</p>
                                <ul className="list-disc list-inside text-left">
                                    <li>Password must contain at least 9 characters</li>
                                    <li>Password must contain an upper case character</li>
                                    <li>Password must contain a numeric character</li>
                                    <li>Password must contain a non-alphanumeric character</li>
                                </ul>
                            </div>
                        );
                        break;
                    default:
                        customErrorMessage = error.message;
                        break;
                }
                setError(customErrorMessage);
                console.error(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="h-screen w-full bg-[#1a2332] flex flex-col items-center justify-center p-4 relative overflow-hidden font-['Inter']">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5 pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-full"
                    style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 5 C 35 15 45 15 45 25 C 45 35 30 50 30 50 C 30 50 15 35 15 25 C 15 15 25 15 30 5 Z' fill='%23ffffff' fill-rule='evenodd'/%3E%3C/svg%3E")`,
                        backgroundSize: '60px 60px'
                    }}
                />
            </div>

            {/* Ambient Glow */}
            <div className="absolute top-1/4 left-1/4 w-[40vh] h-[40vh] bg-purple-500/20 rounded-full blur-[100px] -translate-x-1/2 -translate-y-1/2" />
            <div className="absolute bottom-1/4 right-1/4 w-[40vh] h-[40vh] bg-blue-500/20 rounded-full blur-[100px] translate-x-1/2 translate-y-1/2" />

            <main className="z-10 flex flex-col items-center justify-center w-full max-w-md space-y-8">
                {/* Logo Section */}
                <div className="flex flex-col items-center space-y-6">
                    <div className="relative w-[35vw] h-[35vw] max-w-[180px] max-h-[180px] min-w-[120px] min-h-[120px] flex items-center justify-center transform hover:scale-105 transition-transform duration-500">
                        <img src={splashImage} alt="Cutthroat Spades" className="w-full h-full object-contain drop-shadow-2xl filter brightness-110" />
                    </div>

                    <h1 className="text-2xl sm:text-3xl font-black tracking-tight font-['Roboto_Slab'] text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-yellow-400 mb-2">
                        CREATE ACCOUNT
                    </h1>
                </div>

                <form onSubmit={handleSignUp} className="w-full space-y-4 px-6 sm:px-8">
                    <div className="space-y-4">
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full rounded-xl bg-white/5 border border-white/10 text-white h-12 px-4 text-base placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500/50 transition-all"
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full rounded-xl bg-white/5 border border-white/10 text-white h-12 px-4 text-base placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500/50 transition-all"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full group relative overflow-hidden rounded-2xl bg-gradient-to-r from-amber-500 to-orange-600 p-4 transition-all hover:from-amber-400 hover:to-orange-500 hover:shadow-lg hover:shadow-orange-500/30 active:scale-95 ${loading ? 'opacity-70 cursor-not-allowed' : ''
                            }`}
                    >
                        <span className="relative z-10 text-lg font-bold text-white">
                            {loading ? 'Signing up...' : 'Sign Up'}
                        </span>
                    </button>

                    {error && (
                        <div className="p-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-200 text-sm text-center">
                            {error}
                        </div>
                    )}
                </form>

                <button
                    onClick={onGoToLogin}
                    className="text-sm font-medium text-gray-400 hover:text-white transition-colors"
                >
                    Already have an account? <span className="text-amber-400">Login</span>
                </button>
            </main>
        </div>
    );
};

export default SignUp;